// Los íconos dibujados de la app.
//
// ═══════════════════════════════════════════════════════════════════
// POR QUÉ SVG Y NO EMOJI
// ═══════════════════════════════════════════════════════════════════
//
// La opción barata era 📷. Se descartó por tres razones concretas:
//
//   1. **Trae su propio color.** El emoji lo dibuja el sistema
//      operativo con su paleta, no con la nuestra. Al lado de los
//      símbolos planos que ya usa la app (`×` para cerrar, `✓` para
//      registrado) se ve pegado de otro lado.
//   2. **Cambia de dibujo según el aparato.** La cámara de Android, la
//      de Windows y la de iPhone no se parecen. Un ícono que significa
//      algo no puede depender de quién mira.
//   3. **No hereda el estado.** Encendido y apagado se distinguen por
//      color, y un emoji no obedece a `currentColor`.
//
// El SVG toma el color del texto que lo rodea, así que "fichada" y "sin
// fichar" son la misma forma en dos colores, sin escribir CSS aparte.

/**
 * Cámara: "esta prenda ya se mostró en público".
 *
 * `aria-hidden` porque nunca va solo: siempre lo acompaña un texto o un
 * `aria-label` en el botón que lo contiene. Un ícono anunciado dos
 * veces es peor que uno no anunciado.
 */
export function IconoFichada({ tamano = 16, relleno = false }) {
  return (
    <svg
      width={tamano}
      height={tamano}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ flexShrink: 0, verticalAlign: "-2px" }}
    >
      {/* El cuerpo de la cámara, con la pestaña del visor arriba. */}
      <path d="M3 8.5A1.5 1.5 0 0 1 4.5 7h2.2a1 1 0 0 0 .83-.45l.94-1.4A1 1 0 0 1 9.3 4.7h5.4a1 1 0 0 1 .83.45l.94 1.4A1 1 0 0 0 17.3 7h2.2A1.5 1.5 0 0 1 21 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17.5z" />
      {/* El lente. Relleno cuando está fichada: el estado se lee de
          lejos, sin tener que comparar dos tonos de gris. */}
      <circle cx="12" cy="12.8" r="3.4" fill={relleno ? "currentColor" : "none"} />
    </svg>
  );
}

/**
 * Frasco de perfume (22/9): el botón para elegir el perfume de un
 * registro, y la marca del perfume en el Historial.
 *
 * Un frasco de hombros rectos con tapa y atomizador: se reconoce como
 * perfume y no como botella de agua ni de vino. Relleno cuando hay un
 * perfume elegido, igual que la cámara de «fichada»: el estado se lee
 * de lejos.
 */
export function IconoFrasco({ tamano = 16, relleno = false }) {
  return (
    <svg
      width={tamano}
      height={tamano}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ flexShrink: 0, verticalAlign: "-2px" }}
    >
      {/* El atomizador: el tubito que sale de la tapa. */}
      <path d="M14.5 4.5h3" />
      {/* La tapa. */}
      <rect x="9.5" y="3" width="5" height="4" rx="0.8" />
      {/* El cuello. */}
      <path d="M10.5 7v2M13.5 7v2" />
      {/* El cuerpo del frasco. */}
      <rect x="5.5" y="9" width="13" height="12" rx="2.2" fill={relleno ? "currentColor" : "none"} />
    </svg>
  );
}
